import { useCallback } from 'react';
import { useLogAnalyticsEvent } from 'shared/src/hooks';
import type { Address } from 'mypage/src/api/addressService';

/**
 * 기본 배송지 변경 완료 로깅.
 * iOS `AddressEventLogger.completeChangeShippingAddress` 와 동일 (SHIPPING_ADDRESS = "주소 상세주소").
 * Android `AnalyticsAction.COMPLETE_CHANGE_SHIPPING_ADDRESS` 와 동일.
 *
 * ENABLE-996: bridge 직접 호출 대신 useLogAnalyticsEvent를 사용해 AnalyticsScreen 컨텍스트의
 * SCREEN(="ADDRESS")이 자동 주입되도록 함 (기존엔 SCREEN 누락).
 */
export const useLogCompleteChangeShippingAddress = () => {
  const logAnalyticsEvent = useLogAnalyticsEvent();
  return useCallback(
    (address: Address) => {
      logAnalyticsEvent({
        name: 'COMPLETE_CHANGE_SHIPPING_ADDRESS',
        channel: ['firebase', 'amplitude', 'facebook', 'ablylog'],
        analytics: {
          SHIPPING_ADDRESS: `${address.address} ${address.address_detail}`,
        },
      });
    },
    [logAnalyticsEvent],
  );
};
